<template>
  <div
    v-if="currentWrapUp"
    class="mb-2"
    style="
      box-shadow: 3px 3px 6px 2px #eee;
      border-radius: 5px;
      border: 1px solid #d6d6d6;
      overflow: hidden;
    "
  >
    <div class="pa-2">
      <v-layout align-center wrap>
        <v-flex>
          <template v-if="isEdit">
            <v-text-field
              v-model="currentWrapUp.wrap_up"
              v-validate="'required'"
              :name="`wrap_up_${timestamp}`"
              data-vv-as="Wrap Up"
              outline
              :hide-details="!errors.has(`wrap_up_${timestamp}`)"
              :error="errors.has(`wrap_up_${timestamp}`)"
              :error-messages="errors.first(`wrap_up_${timestamp}`)"
              single-line
              :loading="loading"
            />
          </template>
          <template v-else> Level 1 {{ currentWrapUp.wrap_up }} </template>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <template v-if="!isEdit">
            <v-btn icon color="primary" @click="isEdit = true">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon color="error" @click="deleteWrapUp()">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="grey" outline :loading="loading" @click="handleAddLevel1">
              <v-icon class="mr-2">add</v-icon>
              {{ $t('Add') }}
            </v-btn>
            <v-btn color="grey" outline :loading="loading" @click="handleCancel">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn color="primary" :loading="loading" @click="handleSave">
              {{ $t('Save') }}
            </v-btn>
          </template>
          <v-btn icon @click="showMore = !showMore">
            <v-icon>{{ showMore ? 'expand_less' : 'expand_more' }}</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <template v-if="showMore">
      <div class="pa-2" style="background-color: #eee">
        <template v-for="(wrapUpRoute, index) in currentWrapUp.wrap_up_route">
          <div :key="`wrap_${index}`" class="tree">
            <WrapUpRoute
              :wrap-up-route="wrapUpRoute"
              :parent-key="`${index}`"
              :is-edit="isEdit"
              @updateWrapUpRoute="handleUpdateWrapUpRoute(index, $event)"
              @onDeleteWrapUpRoute="handleDeleteSubWrapUpRoute(index)"
            />
          </div>
        </template>
        <div v-if="isEdit" class="text-xs-center my-2">
          <v-btn color="grey" outline :loading="loading" @click="handleCancel">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" :loading="loading" @click="handleSave">
            {{ $t('Save') }}
          </v-btn>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'
import WrapUpRoute from './WrapUpRoute'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import WrapUpMixin from './WrapUpMixin'
import ticket3PageApi from '@/api/ticket3/page'
export default {
  components: { WrapUpRoute },
  mixins: [WrapUpMixin],
  inject: ['$validator'],
  props: ['wrapUp'],
  data() {
    return {
      showMore: false,
      isEdit: false,
      currentWrapUp: undefined,
      cachedWrapUp: undefined,
      loading: false,
      timestamp: moment().valueOf()
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.currentWrapUp = cloneDeep(this.wrapUp)
    this.cachedWrapUp = cloneDeep(this.wrapUp)
  },
  methods: {
    handleUpdateWrapUpRoute(index, data) {
      const wrapUp = { ...this.currentWrapUp }
      wrapUp.wrap_up_route[index] = data
      this.currentWrapUp = wrapUp
    },
    handleAddLevel1() {
      this.currentWrapUp.wrap_up_route.push({
        title: '',
        subWrapUp: [],
        level: 1,
        name: 'level_1'
      })
    },
    handleCancel() {
      this.isEdit = false
      this.currentWrapUp = cloneDeep(this.cachedWrapUp)
    },
    async handleSave() {
      const result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loading = true
      const saveResult = await this.handleSaveWrapUp({
        pageid: this.selectedBot.pageid,
        currentWrapUp: this.currentWrapUp
      })
      if (saveResult) {
        this.isEdit = false
        this.cachedWrapUp = cloneDeep(this.currentWrapUp)
        this.$emit('updateWrapUp', this.currentWrapUp)
      }
      this.loading = false
    },
    async deleteWrapUp() {
      await this.$swal
        .fire({
          title: this.$t('Do you want to delete this?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch('loading')
            try {
              const response = await ticket3PageApi.deleteWrapUp({
                data: { page_id: this.selectedBot.pageid, id: this.currentWrapUp.id }
              })
              if (response.status == 200 || response.status == 204) {
                this.$emit('deleteWrapUp')
              }
            } catch (error) {
              handleApiError(error)
            } finally {
              this.$store.dispatch('clear_loading')
            }
          }
        })
    },

    handleDeleteSubWrapUpRoute(index) {
      this.currentWrapUp.wrap_up_route.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/WrapUp/WrapUpItem.vue